<template>
    <path
        d="M8.5 2h-4A1.5 1.5 0 0 0 3 3.5v9A1.5 1.5 0 0 0 4.5 14h7a1.5 1.5 0 0 0 1.5-1.5V6.5z"
    />
</template>
